module.exports = __webpack_public_path__ + "static/img/morentouxiang2.9089316.png";